/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Button, NavigationButton, NavigationButtonType } from "@octopusdeploy/design-system-components";
import type { ActionTemplateSearchResource } from "@octopusdeploy/octopus-server-client";
import type { LinkHref } from "@octopusdeploy/portal-routes";
import * as React from "react";
import { StepTile } from "~/areas/projects/components/Process/ActionTemplateSelector/StepTile";
import ActionTemplateCard from "~/components/ActionTemplates/ActionTemplateCard";
import ActionTemplateCardList from "~/components/ActionTemplates/ActionTemplateCardList";
import filterActionTemplates from "~/components/ActionTemplates/filterActionTemplates";
import { isFeatureToggleEnabled } from "~/components/FeatureToggle/New/FeatureToggleContext";
import Section from "~/components/Section/index";
interface BuiltinActionTemplateListProps {
    templates: ActionTemplateSearchResource[];
    filter?: string;
    onPostSelectionUrlRequested?: (template: {
        Type: string;
        Id: string;
    } | string) => LinkHref;
}
class BuiltinActionTemplateList extends React.Component<BuiltinActionTemplateListProps, never> {
    render() {
        const isImproveKubernetesStepSelectionFeatureEnabled = isFeatureToggleEnabled("ImproveKubernetesStepSelectionFeatureToggle");
        const filteredResults = filterActionTemplates(this.props.templates, this.props.filter!);
        if (filteredResults.length === 0 && this.props.filter) {
            return <p>There are no built-in step templates that match your filter criteria.</p>;
        }
        return (<Section sectionHeader="Built-in Step Templates">
                <ActionTemplateCardList>
                    {filteredResults.map((template) => {
                if (isImproveKubernetesStepSelectionFeatureEnabled) {
                    return (<StepTile key={template.Type + template.Id} step={template} primaryActionButton={<Button label={"Add Step"} onClick={() => {
                                // This is a no-op because the <StepTile /> component encapsulates the logic for adding a step.
                            }} importance={"secondary"} size={"small"}/>} primaryRedirect={this.props.onPostSelectionUrlRequested!(template)}/>);
                }
                return (<ActionTemplateCard key={template.Type + template.Id} template={template} primaryAction={<NavigationButton label="Add" type={NavigationButtonType.Primary} href={this.props.onPostSelectionUrlRequested!(template)}/>} primaryRedirect={this.props.onPostSelectionUrlRequested!(template)}/>);
            })}
                </ActionTemplateCardList>
            </Section>);
    }
    static displayName = "BuiltinActionTemplateList";
}
export default BuiltinActionTemplateList;
